export default __webpack_public_path__ + "static/media/coin_erd.73713e3e.svg";